module.exports = __webpack_public_path__ + "static/media/AlertChart.0237ae94.svg";